export class MetalGlobalModel {

    /**
     * First defender
     */
    defender_1: bigint = BigInt(0);

    /**
     * Second defender
     */
    defender_2: bigint = BigInt(0);

    /**
     * Third defender
     */
    defender_3: bigint = BigInt(0);

    /**
     * Fourth defender
     */
    defender_4: bigint = BigInt(0);

    /**
     * Fill values
     * 
     * @param values 
     */
    fill(values: Array<any>) {
        this.defender_1 = this.format(values, 'defender_1');
        this.defender_2 = this.format(values, 'defender_2');
        this.defender_3 = this.format(values, 'defender_3');
        this.defender_4 = this.format(values, 'defender_4');
    }

    /**
     * Format value
     * 
     * @param values
     * @param app
     * @param key
     */
    private format(values: Array<any>, key: string): bigint {
        let value = values.find(x => x.key == 'metal_' + key);
        if (value) {
            return BigInt(value.value);
        } else {
            return BigInt(0);
        }
    }
}